module.exports = __webpack_public_path__ + "static/media/Sport1-Bold.48036449.ttf";